/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const organizationStatsSchema = z.object({
	organization_id: z.uuid(),
	organization_name: z.string(),
	order_count: z.int(),
	total_sum: z.number(),
	avg_check: z.number(),
});
